__turbopack_context__.v({
  "absoluteFilter": "sidebar-module-scss-module__Iyd3Eq__absoluteFilter",
  "absoluteFilterLabel": "sidebar-module-scss-module__Iyd3Eq__absoluteFilterLabel",
  "emptyFooterTags": "sidebar-module-scss-module__Iyd3Eq__emptyFooterTags",
  "footerActions": "sidebar-module-scss-module__Iyd3Eq__footerActions",
  "footerContent": "sidebar-module-scss-module__Iyd3Eq__footerContent",
  "footerTags": "sidebar-module-scss-module__Iyd3Eq__footerTags",
  "headerClose": "sidebar-module-scss-module__Iyd3Eq__headerClose",
  "headerPeriod": "sidebar-module-scss-module__Iyd3Eq__headerPeriod",
  "headerPeriodFrom": "sidebar-module-scss-module__Iyd3Eq__headerPeriodFrom",
  "headerPeriodLabel": "sidebar-module-scss-module__Iyd3Eq__headerPeriodLabel",
  "headerPeriodTo": "sidebar-module-scss-module__Iyd3Eq__headerPeriodTo",
  "headerPeriodWrp": "sidebar-module-scss-module__Iyd3Eq__headerPeriodWrp",
  "headerTitle": "sidebar-module-scss-module__Iyd3Eq__headerTitle",
  "isSidebarOpen": "sidebar-module-scss-module__Iyd3Eq__isSidebarOpen",
  "responsiveContainer": "sidebar-module-scss-module__Iyd3Eq__responsiveContainer",
  "sidebar": "sidebar-module-scss-module__Iyd3Eq__sidebar",
  "sidebarHeader": "sidebar-module-scss-module__Iyd3Eq__sidebarHeader",
  "sidebarHeaderContent": "sidebar-module-scss-module__Iyd3Eq__sidebarHeaderContent",
  "sidebarOverlay": "sidebar-module-scss-module__Iyd3Eq__sidebarOverlay",
  "sidebarWrp": "sidebar-module-scss-module__Iyd3Eq__sidebarWrp",
  "spinnerOverlay": "sidebar-module-scss-module__Iyd3Eq__spinnerOverlay",
  "zerocase": "sidebar-module-scss-module__Iyd3Eq__zerocase",
});
